import { format } from 'date-fns'
import { CheckBox } from '@opallabs/kuiper'

interface AssignmentCheckboxProps {
  checked?: boolean | string
  onClick: (value: boolean) => void
  label?: string
  isMoment?: boolean
  dueDate?: Date
  disabled?: boolean
}

const getLabel = (checked?: boolean | string) =>
  `Task has ${checked ? '' : 'not '}been completed`

const getAriaLabel = (label?: string, isMoment?: boolean, dueDate?: Date) => {
  if (!label) return ''
  const dueDateString =
    dueDate && dueDate.getTime() ? `due ${format(dueDate, 'EEEE LLLL do')}` : ''
  const taskTypeString = `${isMoment ? 'moment' : 'content'} task`
  return `${taskTypeString} ${label} ${dueDateString}`
}

export const AssignmentCheckbox: React.FC<AssignmentCheckboxProps> = ({
  checked,
  onClick,
  isMoment,
  dueDate,
  disabled = false,
  label,
}) => (
  <CheckBox
    onChange={onClick}
    hideLabelText={true}
    label={getLabel(checked)}
    value={checked}
    ariaLabel={getAriaLabel(label, isMoment, dueDate)}
    disabled={disabled}
  />
)
